
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming-syntax.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-streaming-syntax-demo-format"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming-syntax.en-US.md?type=demo')
};